// Canvas drawing for laid-out text, shared by placed object text and card faces.
import { BULLET, bulletX, fontString, type TextLayout } from './layout.ts';

export const TEXT_COLOR = '#1A1A1A';
export const LINK_COLOR = '#2D5BFF';

export type Ctx2D = CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;

/**
 * Draws `layout` with its top-left at (ox, oy). `scale` = device px per world
 * unit (keeps link underlines at least a device pixel thick).
 */
export function drawLayout(ctx: Ctx2D, layout: TextLayout, ox: number, oy: number, color: string, scale: number): void {
  const size = layout.fontSize;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  let font = '';
  const setFont = (f: string) => { if (f !== font) ctx.font = font = f; };
  const underline = Math.max(size * 0.06, 1 / scale);
  for (const ln of layout.lines) {
    if (ln.bullet) {
      setFont(fontString(size));
      ctx.fillStyle = color;
      ctx.fillText(BULLET, ox + bulletX(ln, size), oy + ln.y);
    }
    for (const f of ln.frags) {
      setFont(fontString(size, f.b, f.i));
      ctx.fillStyle = f.href ? LINK_COLOR : color;
      ctx.fillText(f.text, ox + f.x, oy + ln.y);
      if (f.href) ctx.fillRect(ox + f.x, oy + ln.y + size * 0.45, f.w - f.trail, underline);
    }
  }
}
